import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
import IconArrowRight from 'components/icons/iconArrowRight';
import ShowroomLocatorResults from 'components/consumer/consumer-new-footer/components/ShowroomLocatorResults';
import useShowroomLocator from 'hooks/useShowroomLocator';
import useShowroomSearchInput from 'hooks/useShowroomSearchInput';
import CityStateSuggestionsDropdown from 'hooks/useCityStatePlacesAutocomplete/CityStateSuggestionsDropdown';
const MobileNavbarShowroomLocator = t0 => {
  const $ = _c(42);
  const {
    onClose,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "popover" : t1;
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleSearchByPlace,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  const inputRef = useRef(null);
  const formikRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== variant) {
    t2 = () => {
      if (variant === "popover") {
        inputRef.current?.focus();
      }
    };
    t3 = [variant];
    $[0] = variant;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => {
      formikRef.current?.setFieldValue("zipcode", value);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleValueChange = t4;
  let t5;
  if ($[4] !== handleSearch || $[5] !== handleSearchByPlace) {
    t5 = {
      inputRef,
      onValueChange: handleValueChange,
      onSearchByZipcode: handleSearch,
      onSearchByPlace: handleSearchByPlace
    };
    $[4] = handleSearch;
    $[5] = handleSearchByPlace;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    notifyValueChanged,
    validateValue,
    submitValue,
    suggestionsDropdownProps
  } = useShowroomSearchInput(t5);
  const isInMenu = variant === "inMenu";
  const containerClassName = isInMenu ? "w-full px-5 py-3 font-bold [&_a]:!text-brand [&_a]:!underline" : "w-72 px-4 py-3 font-bold [&_a]:!text-brand [&_a]:!underline";
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-gray font-bold text-base">Find your closest showroom</div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isInMenu || $[9] !== onClose) {
    t7 = !isInMenu && onClose && <button type="button" onClick={onClose} className="text-gray p-1" aria-label="Close"><IconClose width={12} height={12} /></button>;
    $[8] = isInMenu;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="flex justify-between items-center mb-2">{t6}{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      zipcode: ""
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== validateValue) {
    t10 = values => {
      const message = validateValue(values.zipcode);
      return message ? {
        zipcode: message
      } : {};
    };
    $[14] = validateValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== submitValue) {
    t11 = t12 => {
      const {
        zipcode
      } = t12;
      submitValue(zipcode);
    };
    $[16] = submitValue;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== notifyValueChanged) {
    t12 = t13 => {
      const {
        values: values_0,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      } = t13;
      return <form onSubmit={handleSubmit}><div className="flex items-stretch"><input id="mobile-navbar-showroom-zipcode" name="zipcode" type="text" placeholder="Zip Code or City, State" aria-label="Zip code or city and state" value={values_0.zipcode} onChange={event => {
            handleChange(event);
            notifyValueChanged(event.target.value);
          }} onBlur={handleBlur} autoComplete="off" ref={inputRef} className="flex-1 border border-gray-light5 px-3 py-2 text-lg outline-none focus:border-brand" /><button type="submit" className="bg-brand text-white px-3 flex items-center justify-center [&_path]:fill-white" aria-label="Search"><IconArrowRight width={16} height={10} /></button></div>{touched.zipcode && errors.zipcode && <div className="text-red text-xs mt-1">{errors.zipcode}</div>}</form>;
    };
    $[18] = notifyValueChanged;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12) {
    t13 = <Formik innerRef={formikRef} initialValues={t9} validate={t10} onSubmit={t11}>{t12}</Formik>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== suggestionsDropdownProps) {
    t14 = suggestionsDropdownProps && <CityStateSuggestionsDropdown {...suggestionsDropdownProps} />;
    $[24] = suggestionsDropdownProps;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== error || $[28] !== handleCloseResults || $[29] !== hasSearched || $[30] !== loading || $[31] !== stores) {
    t16 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={true} />;
    $[27] = error;
    $[28] = handleCloseResults;
    $[29] = hasSearched;
    $[30] = loading;
    $[31] = stores;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== handleViewAll) {
    t17 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[33] = handleViewAll;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== containerClassName || $[36] !== t13 || $[37] !== t14 || $[38] !== t16 || $[39] !== t17 || $[40] !== t8) {
    t18 = <div className={containerClassName} data-testid="mobile-hamburger-store-locator">{t8}{t13}{t14}{t15}{t16}{t17}</div>;
    $[35] = containerClassName;
    $[36] = t13;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
    $[40] = t8;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
MobileNavbarShowroomLocator.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['popover', 'inMenu'])
};
export default MobileNavbarShowroomLocator;